// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"6d80902c","280":"dedbbd44","399":"cf914d81","588":"839a6b7a","683":"66feca54","784":"2e369f3e","787":"bed44058"}[chunkId] + ".chunk.js";
};